"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "H1", {
  enumerable: true,
  get: function get() {
    return _htags.H1;
  }
});
Object.defineProperty(exports, "H2", {
  enumerable: true,
  get: function get() {
    return _htags.H2;
  }
});
Object.defineProperty(exports, "H3", {
  enumerable: true,
  get: function get() {
    return _htags.H3;
  }
});
Object.defineProperty(exports, "H4", {
  enumerable: true,
  get: function get() {
    return _htags.H4;
  }
});
Object.defineProperty(exports, "H5", {
  enumerable: true,
  get: function get() {
    return _htags.H5;
  }
});
Object.defineProperty(exports, "H6", {
  enumerable: true,
  get: function get() {
    return _htags.H6;
  }
});
Object.defineProperty(exports, "Code", {
  enumerable: true,
  get: function get() {
    return _code.Code;
  }
});
Object.defineProperty(exports, "Pre", {
  enumerable: true,
  get: function get() {
    return _code.Pre;
  }
});
Object.defineProperty(exports, "P", {
  enumerable: true,
  get: function get() {
    return _text.P;
  }
});
Object.defineProperty(exports, "A", {
  enumerable: true,
  get: function get() {
    return _text.A;
  }
});
Object.defineProperty(exports, "LI", {
  enumerable: true,
  get: function get() {
    return _text.LI;
  }
});
Object.defineProperty(exports, "UL", {
  enumerable: true,
  get: function get() {
    return _text.UL;
  }
});

var _htags = require("./htags");

var _code = require("./code");

var _text = require("./text");